<style scoped lang="less">
@import "./modal.less";

.account-ercode {
  width: 460px;
  height: 160px;
  border: 1px solid #979797;
  border-radius: 4px;
}

.google-verify-ercode {
  width: 140px;
  height: 140px;
}

.account-ercode {
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}

/deep/ .google-verify-center {
  margin-left: 20px;
  height: 100%;

}

.google-verify-keycode {
  font-size: 18px;
  color: #333;
  margin-top: 20px;
}

.google-verify-copykey {
  margin-top: 20px;
  font-size: 14px;
  color: #42B3FA;
  cursor: pointer;
}

.modal-item {
  .modal-item-base();
  margin-top: 20px;
}
</style>

<template>
  <!-- 谷歌验证模态框 - 开始 -->
  <Modal v-model="vis"
         :loading="true"
         :mask-closable="false"
         @on-cancel="vis = false"
         :title="$t('安全验证')">
    <ListCard class="account-ercode"
              direction="left"
              centerClass="google-verify-center" v-if="userInfo.googleStatus === 0">
      <template #left>
        <div class="google-verify-ercode">
          <canvas class="qrcode-canvas" ref="qrcode"></canvas>
        </div>
      </template>

      <template #center-top>
        <div class="google-verify-keycode" v-text="googleKey"></div>
      </template>

      <template #center-bottom>
        <div class="google-verify-copykey" @click="copyGoogleKey">
          <img src="@/assets/images/icon-fuzhi@2x.png" :alt="$t('复制按钮')" width="14" height="14">
          {{ $t('复制密钥') }}
        </div>
      </template>
    </ListCard>

    <Alert type="warning" show-icon v-if="userInfo.enableGoogleCheck">{{ $t('关闭谷歌验证后') }}24小时内禁止提币</Alert>

    <div class="modal-item">
      <h3>{{ $t('输入新谷歌验证码') }}</h3>
      <input type="text" v-model="code.google">
    </div>
    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="btnLoading.confirm" @click="confimHandle">{{ $t('确认') }}</el-button>
    </template>
  </Modal>
  <!-- 谷歌验证模态框 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
import { ajaxDataShrink, ajaxTry, copyText, ajaxAlert, updateUserInfo, generateQRCode } from '@/utils'
import { ajax_getGoogleKey, ajax_bindGoogleVerify } from '@/api/personal'
import { mapState } from 'vuex'
import qrcode from 'qrcode'

export default {
  name: 'GoogleVerifyModal',
  extends: ModalBase,
  data () {
    return {
      googleKey: '',
      code: {
        google: ''
      }
    }
  },
  inject: {
    whetherVerify: 'whetherVerify'
  },
  computed: {
    ...mapState(['userInfo'])
  },
  async mounted () {
    this.getGoogleKey()
  },
  methods: {
    copyGoogleKey () {
      // 脚本复制 googleKey
      copyText(this.googleKey)
      this.$Notice.success({
        title: '复制成功',
        duration: 0.6
      })
    },
    async getGoogleKey () {
      let [flag, res] = await ajaxTry(ajax_getGoogleKey()).then(ajaxDataShrink)
      if (!flag) return

      this.googleKey = res.data.secretKey
      generateQRCode(this.$refs.qrcode, res.data.qrBarcode)
    },
    confimHandle () {

      this.bindGoogleVerify()

    },
    async bindGoogleVerify () {
      // 绑定 google 验证
      this.btnLoading.confirm = true
      let [flag] = await ajaxTry(ajax_bindGoogleVerify(this.code.google)).then(ajaxAlert).then(updateUserInfo)
      this.btnLoading.confirm = false
      if (flag) this.vis = false
    },
    openGoogleVerify () {
      // 打开 google 验证
      ajaxTry(ajax_openGoogleVerify(this.googleKey)).then(ajaxDataShrink).then(ajaxAlert)
    }
  }

}
</script>
